<template>
  <div>
    <policy-header />
    <privacity-policy />
    <policy-footer />
  </div>
</template>
<script>
import PolicyHeader from 'pages/policy-pages/components/header-policy';
import PrivacityPolicy from 'pages/policy-pages/privacity/components/privacity-policy';
import PolicyFooter from 'pages/policy-pages/components/footer-policy';

export default {
  components: {
    PolicyHeader,
    PrivacityPolicy,
    PolicyFooter,
  },
};
</script>
